import { BaseFiltroPagDTO } from "./base-dto";

export class CicloPlanejFiltrosDTO extends BaseFiltroPagDTO {
  tipo: string;
  data: string;
  aberto: boolean;
  automatico: boolean;
}

export class CicloPlanejamentoParmDTO {
  id: number;
  automatico: boolean;
  aberto: boolean;
  dataCorte: string;
}